import { Button, IconButton } from '@mui/material';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

type Props = {
  onClick: () => void;
  compact?: boolean;
};

export const ScheduleCall = ({ onClick, compact }: Props) => {
  const { translate } = useLocales();

  return compact ? (
    <IconButton onClick={onClick}>
      <Iconify icon="tabler:hours-24" />
    </IconButton>
  ) : (
    <Button
      sx={{ fontWeight: 'fontWeightRegular' }}
      startIcon={<Iconify icon="tabler:hours-24" />}
      onClick={onClick}
    >
      {translate('communicate.call_schedule.call_schedule')}
    </Button>
  );
};
